export const formatter = new Intl.NumberFormat('US', {
    style: 'currency',
    currency: 'USD'
});


export function diffTime(e) {
    const currentDate = new Date().getTime() / (1000 * 60);
    const blockchainDate = new Date(e).getTime() / (1000 * 60);
    const diffMin = Math.floor(currentDate - blockchainDate);
    return diffMin
};

export function diffTimeMilisecondstoMin(e) {
    const currentDate = new Date().getTime(); // miliseconds
    const blockchainDate = e // miliseconds
    const diffTimeMilisecondstoMin = Math.floor((currentDate - blockchainDate)/(1000*60));
    return diffTimeMilisecondstoMin
};